module.exports = __webpack_public_path__ + "media/components/country-flag/static/ee-8cc2c00b953e70806b219305bf91d0ad.svg";